import { withNamespaces } from '>/i18n'

import ImageTag from '~/components/ImageTag'
import PictureTag from '~/components/PictureTag'

import { MOBILE_APP_LINK } from '~/utils/consts'

export default withNamespaces('homepage')(({ title, description, t }) => {
  return (
    <section className='mobile-app-section' id='mobile-app-section'>
      <div className='mobile-app-section__wrapper'>
        <div className='mobile-app-section__content'>
          <h2
            className='mobile-app-section__title'
            dangerouslySetInnerHTML={{ __html: title || t('mobile_app_section.title') }}
          />
          <p
            className='mobile-app-section__description'
            dangerouslySetInnerHTML={{ __html: description || t('mobile_app_section.description') }}
          />
          <div className='mobile-app-section__badges'>
            <a
              className='mobile-app-section__link'
              href={MOBILE_APP_LINK.IOS}
              target='_blank'
              rel='noopener noreferrer'
            >
              <ImageTag
                className='mobile-app-section__badge'
                src='assets/app-store-badge.svg'
                alt='Logo sklepu App Store'
              />
            </a>
            <a
              className='mobile-app-section__link'
              href={MOBILE_APP_LINK.ANDROID}
              target='_blank'
              rel='noopener noreferrer'
            >
              <ImageTag
                className='mobile-app-section__badge'
                src='assets/google-play-badge.png'
                alt='Logo sklepu Google Play'
              />
            </a>
          </div>
        </div>
        <PictureTag
          pictureClassName='mobile-app-section__img'
          src='assets/iphone.png'
          alt='Telefon'
          blankMediaQuery='(max-width: 767px)'
        />
      </div>
    </section>
  )
})
